const GradientButton = ({label, onClick, style = {}}) => {
    return (
        <button type="button" style={style} className="button gradient-button" onClick={onClick}>{label}</button>
    );
}

export default GradientButton;